import qs from "qs";

export class EvClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/evparking`;
  }

  async get() {
    const url = this.baseURL

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async stopAndExit(sessionId) {
    const url = `${this.baseURL}/stop/${sessionId}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getReport(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}/report/${queryString}`;
    const config =
      params && params.format === "xlsx" ? { responseType: "blob" } : undefined;
    const response = await this.httpClient.request("get", url, config);

    return response;

  }
}